import { GenericObject } from "@vahak/core/dist/custom-types/generic-object";
import { generateUrlParamsFromObject } from "@vahak/core/dist/methods/generateUrlParamsFromObject";
import { getPathName } from "./getPathName";

export function generataMaskUrlWithParams(queryParam: GenericObject, maskUrl?: string) {
    return (maskUrl ? maskUrl : getPathName()) + "?" + generateUrlParamsFromObject(queryParam);
}
